<template>
    <div>
        <p
            v-for="(item, index) in data"
            :key="index">
            {{ item.name }} <br >
        </p>
    </div>
</template>
<script lang="ts" setup>
const props = defineProps({
  params: Object
})

const { params } = toRefs(props)

const data: any = ref()

onBeforeMount(() => {
  data.value = params?.value?.data.businesses || {}
})
</script>
